import { T } from "@supersig/validate";
export const buildLiteral = (valueType)=>{
    return T.object({
        type: T.literal("literal"),
        value: valueType
    });
};
